import { ArrowRight } from "lucide-react";
// import { useTracking } from "../../hooks/useTracking";
import "./Button.css";

const Button = ({ text, className, onClick }) => {
  return (
    <div className={`btn ${className}`} onClick={onClick}>
      <div className="btn-inner">
        <p className="text">
          {text}{" "}
          <span className="circle-arrow">
            <ArrowRight />
          </span>
        </p>
      </div>
    </div>
  );
};

export default Button;
